import request from '@/utils/request';

const selectService = {
  getList(url, params) {
    return request({
      url,
      method: 'get',
      params
    });
  }
};

export default selectService;
